<template>
    <div class="caseApply">
        <!-- <div class="caseApplyHead">
            <div class="caseApplyTitle">病案复印助手</div>
        </div> -->
        <div class="myAllOrder">
            <div class="myOneOrder" v-for="item in myOrderList" :key="item.org_name" @click="casePayDesc(item)">
                <div class="orderImg" v-if="item.status=='0'">
                    <a class="saveLogo"></a>
                    <span>未支付</span>
                </div>
                <div class="orderImg" v-if="item.status=='2'">
                    <a class="orderImgLogo"></a>
                    <span>已取消</span>
                </div>
                <div class="orderImg" v-if="item.status=='4'">
                    <a class="payed"></a>
                    <span>已支付</span>
                </div>
                <div class="orderImg" v-if="item.status=='5'">
                    <a class="auditingLogo"></a>
                    <span>通过审核</span>
                </div>
                <div class="orderImg" v-if="item.status=='6'">
                    <a class="noAuditingLogo"></a>
                    <span style="color:#d81e06;">审核未通过</span>
                </div>
                <div class="orderImg" v-if="item.status=='8'">
                    <a class="payed"></a>
                    <span>支付中</span>
                </div>
                <div class="orderImg" v-if="item.status=='9'">
                    <a class="payed"></a>
                    <span>待补款</span>
                </div>
                <div class="orderImg" v-if="item.status=='10'">
                    <a class="payed"></a>
                    <span>已补款</span>
                </div>

                <!-- <div class="orderName">
                    <span class="orderNameMC">项目名称</span>
                    <span class="orderDesc">详细信息</span>
                </div> -->
                <div class="orderTxt">
                    <span class="hospitalName">{{item.org_name}}</span>
                    <span class="orderBTN">{{item.type_srv}}</span>
                    <span class="createTime">{{item.created_time}}</span>
                </div>
                <van-icon name="arrow" />
            </div>
        </div>
    </div>
</template>
<script>
import ApiSetting from '@/assets/js/api'
export default {
    data(){
        return{
            checked:false,
            myOrderList:[]
        }
    },
    mounted(){
      let code = this.$utils.getUrlKey("code");
       if (code !=undefined) {
           this.$http.get(ApiSetting.getOpenId + code).then((response) => {
           })
        }
      this.getordelistbyopenid()
    },
    methods:{
        casePayDesc(item){
            sessionStorage.setItem('myOneOrder',JSON.stringify(item))
            this.$router.push({path:'/casePayDesc'})
        },
        getordelistbyopenid (event) {
            this.postRequest(ApiSetting.getordelistbyopenid).then((res) => {
                if(res.data.responseCode=='200'){
                    this.myOrderList=res.data.data
                }
        })
      }
    },
}
</script>
>

<style lang="less">
.myAllOrder{
    font-size: 0.28rem;
    background: #ffffff;
    .myOneOrder{
        height: 1.6rem;
        overflow: hidden;
        border-bottom: 1px solid #e4e4e4;
        .orderImg{
            width: 1.6rem;
            height: 1.6rem;
            float: left;
            text-align: center;
            .saveLogo{
                height: 0.7rem;
                width: 0.7rem;
                display: inline-block;
                background:url('../assets/images/saveOrder.png') no-repeat;
                background-size: 100%;
                margin-top: 0.3rem;
            }
            .auditingLogo{
                height: 0.7rem;
                width: 0.7rem;
                display: inline-block;
                background:url('../assets/images/saveOrder.png') no-repeat;
                background-size: 100%;
                margin-top: 0.3rem;
            }
            .noAuditingLogo{
                height: 0.7rem;
                width: 0.7rem;
                display: inline-block;
                background:url('../assets/images/noAuditing.png') no-repeat;
                background-size: 100%;
                margin-top: 0.3rem;
            }
            .payed{
                height: 0.7rem;
                width: 0.7rem;
                display: inline-block;
                background:url('../assets/images/payed.png') no-repeat;
                background-size: 100%;
                margin-top: 0.3rem;
            }
            span{
                display: block;
                height: 0.4rem;
                line-height: 0.4rem;
            }
        }
        .orderName{
            float: left;
            margin-right: 0.2rem;
            span{
                display: block;
                height: 0.8rem;
                line-height: 0.8rem;
                border-left: 1px solid #e4e4e4;
                padding-left: 0.1rem;
            }
            .orderNameMC{
                font-size: 0.32rem;

            }
            .orderDesc{
                color: #999999;
            }
        }
        .orderTxt{
            float: left;
            width: 5.2rem;
            span{
                display: block;
                padding-left: 0.1rem;
            }
            .createTime{
                display: inline-block;
                float: right;
                color: #1c84f2;
            }
            .hospitalName{
                height: 1rem;
                line-height: 1rem;
                font-size: 0.32rem;
                font-weight: 600;
                width: 5.2rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .orderBTN{
                height: 0.4rem;
                line-height: 0.4rem;
                font-size: 0.24rem;
                border-radius: 1rem;;
                color: #ffffff;
                background: #1C84F2;
                text-align: center;
                margin-left: 0.1rem;
                padding: 0 0.2rem;
                width: auto;
                display: inline-block;
            }
        }
        .van-icon{
            float: right;
            margin-right: 0.2rem;
            margin-top: 0.7rem;
        }
    }
}
</style>

